import { STAGES } from "../lib/stages";
import styles from "./BoardFilters.module.css";

export interface Filtros {
  busca: string;
  etapa: number | null;
  paradoDias: number | null;
}

const PARADO_OPCOES = [
  { label: "Qualquer", value: null },
  { label: "≥ 3 dias", value: 3 },
  { label: "≥ 7 dias", value: 7 },
  { label: "≥ 14 dias", value: 14 },
  { label: "≥ 30 dias", value: 30 },
];

export function BoardFilters({ filtros, onChange }: { filtros: Filtros; onChange: (f: Filtros) => void }) {
  return (
    <div className={styles.bar}>
      <input
        className={styles.search}
        type="search"
        placeholder="Buscar por nome do cliente…"
        value={filtros.busca}
        onChange={(e) => onChange({ ...filtros, busca: e.target.value })}
      />

      <label className={styles.selWrap}>
        <span className="dim">Etapa</span>
        <select
          value={filtros.etapa ?? ""}
          onChange={(e) => onChange({ ...filtros, etapa: e.target.value ? Number(e.target.value) : null })}
        >
          <option value="">Todas</option>
          {STAGES.map((s) => (
            <option key={s.n} value={s.n}>
              {s.n}. {s.label}
            </option>
          ))}
        </select>
      </label>

      <label className={styles.selWrap}>
        <span className="dim">Parado há</span>
        <select
          value={filtros.paradoDias ?? ""}
          onChange={(e) => onChange({ ...filtros, paradoDias: e.target.value ? Number(e.target.value) : null })}
        >
          {PARADO_OPCOES.map((o) => (
            <option key={o.label} value={o.value ?? ""}>
              {o.label}
            </option>
          ))}
        </select>
      </label>

      {(filtros.busca || filtros.etapa != null || filtros.paradoDias != null) && (
        <button
          className={styles.clear}
          onClick={() => onChange({ busca: "", etapa: null, paradoDias: null })}
        >
          Limpar
        </button>
      )}
    </div>
  );
}
